import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { QUALIFICHE } from "./schemas";

// Iter 105: rende un campo del form a partire dallo schema
export function SchemaField({ f, value, onChange, sedi = [] }) {
  const id = `risorse-field-${f.k}`;
  if (f.t === "bool") {
    return (
      <div className="flex items-center justify-between border rounded-md px-3 py-2">
        <Label htmlFor={id} className="font-bold text-sm">{f.l}</Label>
        <Switch id={id} checked={value !== false} onCheckedChange={onChange} data-testid={id} />
      </div>
    );
  }
  if (f.t === "quals") {
    return (
      <div>
        <Label className="font-bold text-xs">{f.l}</Label>
        <div className="flex flex-wrap gap-1.5 mt-1">
          {QUALIFICHE.map((q) => {
            const on = (value || []).includes(q.v);
            return (
              <button
                type="button"
                key={q.v}
                onClick={() => onChange(on ? value.filter((x) => x !== q.v) : [...(value || []), q.v])}
                className={`rounded-full px-3 py-1 text-xs font-bold border transition-colors ${on ? "bg-[#0044FF] text-white border-[#0044FF]" : "bg-white text-slate-600 border-slate-300 hover:border-[#0044FF]"}`}
                data-testid={`${id}-${q.v}`}
                title={q.l}
              >
                {q.v}
              </button>
            );
          })}
        </div>
      </div>
    );
  }
  if (f.t === "select") {
    return (
      <div>
        <Label className="font-bold text-xs">{f.l}</Label>
        <Select value={value || ""} onValueChange={onChange}>
          <SelectTrigger className="h-10 mt-1" data-testid={id}><SelectValue /></SelectTrigger>
          <SelectContent>
            {f.options.map((o) => <SelectItem key={o.v} value={o.v}>{o.l}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    );
  }
  if (f.t === "sede") {
    return (
      <div>
        <Label className="font-bold text-xs">{f.l}</Label>
        <Input list={`${id}-list`} value={value || ""} onChange={(e) => onChange(e.target.value)} className="h-10 mt-1" data-testid={id} autoComplete="off" />
        <datalist id={`${id}-list`}>{sedi.map((s) => <option key={s.id} value={s.nome} />)}</datalist>
      </div>
    );
  }
  if (f.t === "textarea") {
    return (
      <div className="sm:col-span-2">
        <Label className="font-bold text-xs">{f.l}</Label>
        <Textarea value={value || ""} onChange={(e) => onChange(e.target.value)} rows={2} className="mt-1" data-testid={id} />
      </div>
    );
  }
  if (f.t === "list") {
    return (
      <div className="sm:col-span-2">
        <Label className="font-bold text-xs">{f.l}</Label>
        <Input value={(value || []).join(", ")} onChange={(e) => onChange(e.target.value.split(",").map((s) => s.trim()).filter(Boolean))} className="h-10 mt-1" data-testid={id} />
      </div>
    );
  }
  return (
    <div>
      <Label className="font-bold text-xs">{f.l}{f.req && " *"}</Label>
      <Input
        type={f.t === "date" ? "date" : f.t === "number" ? "number" : "text"}
        value={value ?? ""}
        onChange={(e) => onChange(f.t === "number" ? Number(e.target.value) : e.target.value)}
        className={`h-10 mt-1 ${f.mono ? "font-mono uppercase" : ""}`}
        data-testid={id}
        autoComplete="off"
      />
    </div>
  );
}
